import { endpoints } from '@/Constants';
import { authHeader } from '@/Helpers';
import handleResponse from './helpers';

const utilsServices = {
	getBase64FromFileUrl,
};

function getBase64FromFileUrl(req = {}) {
	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req?.data,
		}),
	};
	return fetch(endpoints.GET_BASE64_FROM_FILE_URL, requestOptions).then(handleResponse);
}

export default utilsServices;
